// removed by extract-text-webpack-plugin
module.exports = {"vadpLogin":"vadpLogin___2TL2e","container":"container___3P6sQ","title":"title___2ZOnP","autofill-fix":"autofill-fix___3guNu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForDark/index.less
// module id = 315
// module chunks = 0